export const DOWNLOAD_API_URL = `${process.env.API_BASE_URL_AI}/v1/common/file/download`

export const LOGIN_AUTHORIZATION = 'Basic YWlfZmxvdzphaV9mbG93X3Bhc3M='
